import type {ReactElement} from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import {ControlledList} from '@Components/controlled-list';
import type {NavDropdownMenuProps} from './nav-dropdown-menu.types';

export function NavDropdownMenu({selector, items, onItemClick, popupClassName}: NavDropdownMenuProps): ReactElement {
  return (
    <Dropdown
      selector={selector}
      popup={<ControlledList items={items} onClick={onItemClick} />}
      alignment={ALIGNMENT_TYPE.BOTTOM_START}
      popUpHasCustomWidth
      popupClassName={popupClassName}
    />
  );
}
